import { Typography } from '@mui/material';
import React from 'react';
import { displayDate } from 'utils/date';

type PubDateProps = {
  pubDateInMillis: number;
};

const PubDate: React.FC<PubDateProps> = ({ pubDateInMillis }) => (
  <Typography variant="body1">{`Published on ${displayDate(
    pubDateInMillis,
    'MM.DD.YYYY',
  )}`}</Typography>
);
export default PubDate;
